import { useState } from 'react';
import { Trash2, Edit2, CheckCircle } from 'lucide-react';
import StarRating from './StarRating';
import { format } from 'date-fns';

const ReviewCard = ({ review, isOwnReview, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'MMM dd, yyyy');
    } catch {
      return dateString;
    }
  };

  return (
    <div className="glass-effect p-6 rounded-xl" data-testid={`review-${review.id}`}>
      {/* User Info */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          {review.user?.picture ? (
            <img 
              src={review.user.picture} 
              alt={review.user.name} 
              className="w-10 h-10 rounded-full"
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center">
              <span className="text-white font-semibold">
                {review.user?.name?.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
          <div>
            <div className="flex items-center space-x-2">
              <h4 className="font-semibold">{review.user?.name || 'Anonymous'}</h4>
              {review.verified_purchase && (
                <span className="flex items-center space-x-1 text-xs text-green-500">
                  <CheckCircle size={14} />
                  <span>Verified Purchase</span>
                </span>
              )}
            </div>
            <p className="text-xs text-gray-400">{formatDate(review.created_at)}</p>
          </div>
        </div>
        
        {/* Edit/Delete buttons for own reviews */}
        {isOwnReview && (
          <div className="flex space-x-2">
            <button
              onClick={() => onEdit(review)}
              className="text-gray-400 hover:text-white transition"
              title="Edit review"
              data-testid="edit-review-btn"
            >
              <Edit2 size={18} />
            </button>
            <button
              onClick={() => onDelete(review.id)}
              className="text-red-500 hover:text-red-400 transition"
              title="Delete review"
              data-testid="delete-review-btn"
            >
              <Trash2 size={18} />
            </button>
          </div>
        )}
      </div>

      {/* Rating */}
      <div className="mb-3">
        <StarRating rating={review.rating} readonly={true} size={18} />
      </div>

      {/* Comment */}
      {review.comment && (
        <p className="text-gray-300 leading-relaxed">{review.comment}</p>
      )}
    </div>
  );
};

export default ReviewCard;